<template>
  <AccessHandler
    :requiredRoleGroups="roleGroups"
    @accessChanged="(a: boolean) => (hasAccess = a)"
  />
  <div class="submissions-page">
    <MasterPage>
      <template v-if="!isMobile() && hasAccess" v-slot:content>
        <header class="page__header--container clearfix">
          <h1 class="page__title--text pull-left">
            PRODUCT AND INGREDIENT REQUESTS
          </h1>
        </header>
        <SubmissionsView />
        <GlobalFooter />
      </template>
      <template v-else-if="hasAccess" v-slot:content>
        <div class="submissions-panel-title">
          <span class="submissions-title" data-cy="submissions-title"
            >Submission List</span
          >
        </div>
        <SubmissionsMobileView />
        <GlobalFooter />
      </template>
    </MasterPage>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import MasterPage from "../MasterPage.vue";
import { useMainStore } from "@/stores/useMainStore";
import GlobalFooter from "@/views/GlobalFooter.vue";
import SubmissionsView from "./SubmissionsView.vue";
import {
  ProductAppGroup,
  IngredientsAppGroup,
  type RoleGroup,
} from "@/shared/access/RoleGroups";
import { UserRoles } from "@/Domain/UserRoles";
import AccessHandler from "@/shared/access/AccessHandler.vue";
import SubmissionsMobileView from "./SubmissionsMobileView.vue";
import { isMobile } from "../../shared/helpers/mobileHelper";

const main = useMainStore();

const roleGroups = [
  {
    roles: [
      UserRoles.ROLE_INGREDIENT,
      IngredientsAppGroup.roles,
      ProductAppGroup.roles,
    ],
    validateRestrictionsAsync: async () => {
      return main.companySummary?.denials.every(
        (d) =>
          (!d.IA || d.IA.toUpperCase() !== "ALL") &&
          (!d.Products || d.Products.toUpperCase() !== "ALL")
      );
    },
  },
] as RoleGroup[];

const hasAccess = ref<boolean>(false);
</script>

<style scoped lang="scss">
.page {
  &__header--container {
    display: flex;
    align-items: center;
    margin-top: 30px;
    gap: 12px;
  }

  &__title--text {
    font-size: 24px;
    line-height: 28px;
    font-weight: 600;
    text-transform: uppercase;
  }
}

.submissions-panel-title {
  padding: 5px 15px;
  display: flex;
  font-size: 11px;
  background: #222;

  .submissions-title {
    color: white;
    font-weight: bold;
    font-size: 12px;
  }
}

.header-help-link {
  text-decoration: none;
  &:hover {
    color: #0a58ca;
  }
}
</style>
